<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/shared/utils/cn";
import { Primitive, type PrimitiveProps } from "reka-ui";

import { badgeRootVariants, type BadgeRootVariants } from "./index";

interface Props extends PrimitiveProps {
    type: BadgeRootVariants["type"];
    size?: BadgeRootVariants["size"];
    color: BadgeRootVariants["color"];
    class?: HTMLAttributes["class"];
}

const props = withDefaults(defineProps<Props>(), {
    as: "div",
});
</script>

<template>
    <Primitive
        data-slot="badge"
        :as="as"
        :class="cn(badgeRootVariants({ type, size, color }), props.class)"
    >
        <slot> </slot>
    </Primitive>
</template>
